import { displayToast, sendAppsignalError } from "../modules/utils";

class CreateDistributor {
  constructor(element) {
    this.element = element;

    this.checkboxTrigger = this.element.querySelector(".js-checkbox-trigger");
    this.coOwnerWrapper = this.element.querySelector(".js-co-owner-wrapper");
    this.newFormWrapper = this.element.querySelector(".js-new-owner-wrapper");
    this.newFormButton = this.element.querySelector(".js-add-new-co-owner-button");
    this.formContent = this.element.querySelector(".js-co-owner-content");

    this.fetchUrl = this.element.dataset.url;

    this.initialized = false;
    this.initialize();
  }

  initialize() {
    if (this.checkboxTrigger.checked) {
      this.toggleCoOwnerForm();

      this.initialized = true;
      const existingDeleteButtons = this.element.querySelectorAll(".js-remove-new-co-owner-button");

      existingDeleteButtons.forEach((button) => {
        button.addEventListener("click", () => {
          button.closest(".content-wrapper").remove();
        });
      });
    }

    this.checkboxTrigger.addEventListener("change", () => {
      if (!this.initialized) {
        this.fetchNewForm();
        this.initialized = true;
      }
      this.toggleCoOwnerForm();
    });

    this.newFormButton.addEventListener("click", () => {
      this.fetchNewForm();
    });
  }

  toggleCoOwnerForm() {
    const inputFields = this.coOwnerWrapper.querySelectorAll("input, select, textarea");

    inputFields.forEach((input) => {
      input.disabled = !this.checkboxTrigger.checked;
    });

    this.coOwnerWrapper.classList.toggle("d-none");
  }

  fetchNewForm() {
    const existingWrappers = this.element.querySelectorAll(".content-wrapper");

    existingWrappers.forEach((element) => {
      element.classList.add("is-loading");
    });

    fetch(this.fetchUrl, {
      retries: 3,
      retryDelay: 1000,
    })
      .then((response) => {
        this.response = response;

        if (response.status === 200) {
          return response.json();
        }

        throw new Error("Something went wrong");
      })
      .then((data) => {
        const { html } = data;
        const newForm = document.createElement("div");
        const id = Date.now().toString();

        newForm.innerHTML = html;
        newForm.id = id;

        this.formContent.appendChild(newForm);
        window.Beyuna.initClasses(document.getElementById(id)); // load all custom js for the newly added form

        const removeButton = newForm.querySelector(".js-remove-new-co-owner-button");

        removeButton.addEventListener("click", () => {
          newForm.remove();
        });
      })
      .catch((e) => {
        console.error(e);
        displayToast(this.element.dataset.errorMessage);
        sendAppsignalError(e, "CreateDistributor", {
          response: this.response,
        });
      })
      .finally(() => {
        existingWrappers.forEach((element) => {
          element.classList.remove("is-loading");
        });
      });
  }
}

const createDistributorElements = document.querySelectorAll("[data-js='create-distributor-form']");

createDistributorElements.forEach((element) => {
  new CreateDistributor(element);
});
